import { render, staticRenderFns } from "./titleRow.vue?vue&type=template&id=5b5b3c06&scoped=true"
import script from "./titleRow.vue?vue&type=script&lang=js"
export * from "./titleRow.vue?vue&type=script&lang=js"
import style0 from "./titleRow.vue?vue&type=style&index=0&id=5b5b3c06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b3c06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5b3c06')) {
      api.createRecord('5b5b3c06', component.options)
    } else {
      api.reload('5b5b3c06', component.options)
    }
    module.hot.accept("./titleRow.vue?vue&type=template&id=5b5b3c06&scoped=true", function () {
      api.rerender('5b5b3c06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/ITA/modules/titleRow.vue"
export default component.exports